module.exports = __webpack_public_path__ + "img/geep-logo-02.a435557a.jpeg";